import DashboardActionTypes from './DashboardActionTypes'

export interface SetOpenCycle {
  type: DashboardActionTypes.SET_OPEN_CYCLE;
  payload: {
    step: number
    cycleCode: string
  }
}

export function setOpenCycle({
  cycleCode,
  step,
}: SetOpenCycle['payload']): SetOpenCycle {

  return {
    type: DashboardActionTypes.SET_OPEN_CYCLE,
    payload: {
      step,
      cycleCode,
    },
  }
}
